import PiarcHero from "./components/PiarcHero";
import PiarcWhatIs from "./components/PiarcWhatIs";
import PiarcResearchAreas from "./components/PiarcResearchAreas";
import PiarcProcess from "./components/PiarcProcess";
import PiarcPathwayNav from "./components/PiarcPathwayNav";
import PiarcOutcomes from "./components/PiarcOutcomes";

export default function Piarc() {
  return (
    <main className="min-h-screen">
      <PiarcHero />
      <PiarcWhatIs />
      <PiarcResearchAreas />
      <PiarcProcess />
      <PiarcPathwayNav />
      <PiarcOutcomes />
    </main>
  );
}